<p-divider>
  <h4><b>Column Preference</b></h4>
</p-divider>
<p >Manage columns preferences for your table</p>
<div class="mb-3">
  <p-tabs [value]="getActivePreferenceIndex()" (valueChange)="switchTAB($event)">
  <p-tablist>
    @for (tab of ColumnPreferencesTab; track $index) {
      <p-tab [value]="$index">{{ tab.title }}</p-tab>
    }
  </p-tablist>
</p-tabs>
</div>

<div class="section-details">
  <ng-container *ngIf="activeColumnPreference.title === PreferenceTab.KPI">
    <app-kpi-preference></app-kpi-preference>
  </ng-container>
  <ng-container *ngIf="activeColumnPreference.title === PreferenceTab.TASKBANK">
    <app-task-bank-preference></app-task-bank-preference>
  </ng-container>
  <ng-container *ngIf="activeColumnPreference.title === PreferenceTab.MAINKPI">
    <app-main-kpi-preference></app-main-kpi-preference>
  </ng-container>
</div>